import { motion } from 'framer-motion';
import ChatHeader from './ChatHeader';
import { useChat } from '../../context/ChatContext';
import Messages from '../../ui/Chatbot/Messages';
import Prompt from '../../ui/Chatbot/Prompt';

const CHAT_WIDTH = 356;

const Chat = () => {
    const { isChatOpen } = useChat();

    return (
        <motion.div initial={{ width: 0 }} animate={{ width: isChatOpen ? CHAT_WIDTH : 0, marginLeft: isChatOpen ? 8 : 0 }} className='flex-shrink-0 absolute right-0 h-screen lg:relative lg:h-auto'>
            <motion.div initial={{ width: CHAT_WIDTH }} className='bg-white h-[calc(100%-45px)] flex-shrink-0 rounded-tl-xl shadow lg:shadow-none'>
                <ChatHeader />

                <div className='w-full h-[calc(100%-37px)] p-2 flex flex-col relative'>
                    <Messages />
                    <div className='flex flex-col mb-4'>
                        <Prompt />
                        <span className='text-[9px] text-center text-gray-500'>As respostas do assistente virtual podem conter erros. <a href='https://plus.sak.com.br' target='_blank' className='text-blue-500 underline'>Consulte o FAQ.</a></span>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
};

export default Chat;